module.exports = __webpack_public_path__ + "img/discover_white.46dd3f7.svg";